import revive_payload_client_4sVQNw7RlN from "/home/node/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/home/node/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/home/node/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import _0_siteConfig_MwZUzHrRNP from "/home/node/app/node_modules/nuxt-site-config/dist/runtime/nuxt/plugins/0.siteConfig.js";
import payload_client_yVLowv6hDl from "/home/node/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import navigation_repaint_client_bs2bWDGRIE from "/home/node/app/node_modules/nuxt/dist/app/plugins/navigation-repaint.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/home/node/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import chunk_reload_client_UciE0i6zes from "/home/node/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import components_plugin_KR1HBZs4kY from "/home/node/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/home/node/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_ksq7gplbDw from "/home/node/app/node_modules/@twicpics/components/nuxt3/plugin.js";
import vCalendar_81sNONyGsI from "/home/node/app/node_modules/@yescapa-dev/ysc-components/dist/runtime/plugins/vCalendar.mjs";
import switch_locale_path_ssr_8BKffvaEi5 from "/home/node/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.mjs";
import i18n_yfWm7jX06p from "/home/node/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.mjs";
import sentry_3AyO8nEfhE from "/home/node/app/plugins/sentry.ts";
import ysc_api_js_owuqPMpeDd from "/home/node/app/plugins/ysc-api-js.ts";
import ysc_gtm_client_mkeAX9SA0v from "/home/node/app/plugins/ysc-gtm.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  _0_siteConfig_MwZUzHrRNP,
  payload_client_yVLowv6hDl,
  navigation_repaint_client_bs2bWDGRIE,
  check_outdated_build_client_8vK7RkfGxZ,
  chunk_reload_client_UciE0i6zes,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  plugin_ksq7gplbDw,
  vCalendar_81sNONyGsI,
  switch_locale_path_ssr_8BKffvaEi5,
  i18n_yfWm7jX06p,
  sentry_3AyO8nEfhE,
  ysc_api_js_owuqPMpeDd,
  ysc_gtm_client_mkeAX9SA0v
]